export const GROUP_SLUG_PATTERN = '{groupSlug}';

export const GROUPS_API_URL = '/_api/clubs-web/v1/groups';

export const PUB_SUB_CHANNEL_APP = 'groups-app';
export const PUB_SUB_CHANNEL_MODAL = 'groups-site-root-modal';

export const MEMBER_PRIVACY_STATUS_PUBLIC = 'PUBLIC';
export const MEMBER_PRIVACY_STATUS_PRIVATE = 'PRIVATE';
